module.exports = __webpack_public_path__ + "media/packs/App/assets/fonts/materialdesignicons-webfont-f60b16c8d4cd35506d0bae8fea644bf3.ttf";